'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('../scores/paths');

var _paths2 = require('../events/paths');

var _paths3 = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (person_id, feis_id) {
  return function (dispatch, getState) {
    var commentedEvents = (0, _paths2.getParticipatedEventsForScoring)(getState(), feis_id, person_id).map(function (eid) {
      return (0, _paths3.getCommentsForPersonInEvent)(getState(), person_id, eid);
    });

    // prefer the cached version
    if (commentedEvents.size > 0) return;

    return dispatch(_defineProperty({
      person_id: person_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisPrefixUrl)(feis_id) + '/results/by-person/' + person_id
      },
      types: ['GET_RESULTS_START', 'GET_RESULTS', 'GET_RESULTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/person/getIndividualResults.js
// module id = 236
// module chunks = 0